// SectionHeader.jsx

import { ModalWithAction } from "../common_components/modal_with_action";
import { txrb } from "../common_components/text_style_components";

/**
 * shows question title with section id on the right
 */
 function QuestionSectionHeader({
  heading="",
  currentSection=-1,
  totalSectionsCount=-1,
  sectionName="",
  // callback to be invoked on button click
  moveToNextSection = () => {},
}) {
  return (
      <header className="flex flex-row justify-evenly  items-center  ">
      {/* 70 % → heading */}
      <h2 className="text-2xl 
      items-center py-4 font-mono text-left sm:text-left">
        {heading}  &nbsp;&nbsp;&nbsp;
      </h2>
       
      {/* 30 % → counter (right-aligned) */}
      <div className="flex flex-col rounded-md font-bold
      text-center  text-sm  px-16 pl-2 pr-4 py-1
         text-teal-700 shrink-0 bg-white">
        Current Section {currentSection}/{totalSectionsCount}
        <br />
        <span className="text-gray-700 text-sm">
          {sectionName} </span>
      </div>
      &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
     { 
      <ModalWithAction 
        buttonText=" Move to Next Section >>"
        actionText="Yes, Move to Next Section"
        onAction={moveToNextSection}
       >
        <MoveToNextSectionConfirmationText />
        </ModalWithAction>
      }
    {/* Move to Next Section button (teal design) */}
    { false &&
     <button
        type="button"
        onClick={moveToNextSection}
        className="shrink-0  px-4 py-2 font-bold
        rounded-full flex flex-row justify-center items-center
         text-teal-700 text-center bg-white hover:bg-teal-100 
          focus:ring-2 focus:ring-teal-500 focus:outline-none
          focus:ring-offset-2 active:scale-95 transition"
      >
        Move to Next Section
        <span className="text-2xl px-1 font-bold">{' >>'}</span>
      </button>
    }
    </header>
  );
}

function MoveToNextSectionConfirmationText(){
  return (
    <div className="flex flex-col text-gray-700 font-mono">
      <br /> 
      <div className="text-gray-800 font-bold text-2xl">
        Are you sure you want to move to next section ???
      </div>
      <br /> 
        <div>You will {txrb("NOT")} be able to come back to this section discussion.</div>
        <br />
        <div>So, make sure you have already covered the required topics for this section. </div>
     <br />
    </div>
  )
}

export {QuestionSectionHeader}